/* Tysk katalog for locale-manual-preview-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'manualPreview.reset': 'Zurücksetzen',
  'manualPreview.title': 'Buchung',
  'manualPreview.details': 'Details',
  'manualPreview.summary': 'Zusammenfassung je Konto',
  'manualPreview.date': 'Datum',
  'manualPreview.account': 'Konto',
  'manualPreview.vat': 'MwSt.-Code',
  'manualPreview.before': 'Saldo vorher',
  'manualPreview.amount': 'Betrag',
  'manualPreview.after': 'Saldo nachher',
  'manualPreview.debit': 'Soll',
  'manualPreview.credit': 'Haben',
  'manualPreview.net': 'Nettoveränderung',
  'manualPreview.warning.balances': 'Salden sind aus der Buchhaltungsgrundlage nicht verfügbar. Die Buchungen werden ohne Saldo vorher und nachher angezeigt.',
  'manualPreview.warning.editing': 'Bei einer Korrektur wird hier die Ersatzbuchung angezeigt. Saldo vorher und nachher werden nicht angezeigt, da die Korrektur auch einen früheren Beleg stornieren kann.',
  'manualPreview.warning.years': 'Die Buchungen erstrecken sich über mehrere Kalenderjahre. Die Buchungszeilen werden angezeigt, aber Saldo vorher und nachher wird nicht jahresübergreifend berechnet.',
  'manualPreview.warning.country': 'Der Vorschau fehlt das Buchhaltungsland, oder sie unterstützt die gewählte MwSt.-Behandlung für das Land nicht.',
});
